<template>
  <div
    class="sub-header-container"
    v-if="$route.query.title === '百家在线' && personalObject.userInfo"
    :style="{ top: scrollTop + 'px' }"
  >
    <div class="sub-wrapper">
      <div class="sub-top">
        <div class="sub-left">
          <div class="avatar">
            <img
              v-lazy="$global.imgUrl + personalObject.userInfo.headPhoto"
              alt=""
              v-if="personalObject.userInfo.headPhoto"
            />
            <span v-else>
              <Big
                width="100"
                height="100"
                size="40"
                :big="personalObject.userInfo.realname"
              />
            </span>
            <!-- <img :src="require('@/assets/img/login/4.png')" alt="" /> -->
          </div>
          <div class="personal">
            <h2 class="name">{{ personalObject.userInfo.realname }}</h2>
            <div class="title">
              职称：<span v-for="v in personalObject.sysUserTitle" :key="v.id"
                >{{ v.levelTwo }}
              </span>
            </div>
          </div>
          <div class="research">
            <div class="school">
              <span
                @click="
                  handleClick(
                    personalObject.userInfo.orgId,
                    personalObject.organizationStatus
                  )
                "
                >{{ personalObject.userInfo.unit }}</span
              >{{ personalObject.userInfo.job ? ' - '+ personalObject.userInfo.job : '' }}
            </div>
            <div class="subject">
              研究领域：<span
                v-for="v in personalObject.sysUserSubject"
                :key="v.id"
                >{{ v.levelTwoName }} </span
              >
            </div>
          </div>
        </div>
        <!-- <a
          :href="$global.baijiaUrl +'autherplain?id=' + $route.query.id"
          target="_blank"
          class="sub-right"
          >详细信息</a
        > -->
        <a @click="toUrl($route.query.id)" target="_blank" class="sub-right"
          >详细信息</a
        >
      </div>
      <div class="sub-nav">
        <span
          :class="activeId === item.id ? 'isActive' : ''"
          v-for="item in subList"
          :key="item.id"
          @click="changeNav(item.name, item.id)"
          >{{ item.title }}</span
        >
        <!-- <router-link
          v-for="(nav, i) in subList"
          :key="i"
          :to="{
            name: nav.name,
            query: { title: $route.query.title, id: $route.query.id },
          }"
        >
          {{ nav.title }}
        </router-link> -->
      </div>
    </div>
  </div>
  <div
    class="sub-header-container"
    :style="{ top: scrollTop + 'px' }"
    v-else-if="$route.query.title === '百科在线'"
  >
    <div class="sub-wrapper">
      <div class="sub-top">
        <div class="sub-left">
          <div class="avatar">
            <img
              v-lazy="$global.imgUrl + personalObject.periodicalLogo"
              alt=""
              v-if="personalObject.periodicalLogo"
            />
            <img
              :src="require('@/assets/img/details/qikan.png')"
              alt=""
              v-else
            />
          </div>
          <div class="personal1">
            <h2 class="name">{{ personalObject.name }}</h2>
            <div>
              主管单位：
              <span
                v-if="
                  personalObject.responsibleDeptList &&
                  personalObject.responsibleDeptList.length > 0
                "
              >
                <span
                  v-for="item in personalObject.responsibleDeptList"
                  :key="item.orgId"
                  class="zg"
                  @click="handleClick(item.orgId, item.orgStatus)"
                  >{{ item.orgName }}</span
                >
              </span>
              <!-- <span v-else :class="['zg', item.orgStatus === 0 ||item.orgStatus == undefined ? 'status' : '']"> -->
              <span v-else :class="['zg', 'status']">
                {{ personalObject.responsibleDept }}
              </span>
              主办单位：
              <span
                v-if="
                  personalObject.organizerList &&
                  personalObject.organizerList.length > 0
                "
              >
                <span
                  v-for="item in personalObject.organizerList"
                  :key="item.orgId"
                  class="zb"
                  @click="handleClick(item.orgId, item.orgStatus)"
                  >{{ item.orgName }}</span
                >
              </span>
              <!-- <span v-else :class="['zb', item.orgStatus === 0 ||item.orgStatus == undefined ? 'status' : '']"> -->
              <span v-else :class="['zb', 'status']">
                {{ personalObject.organizer }}
              </span>
            </div>
          </div>
        </div>
        <a @click="toUrl(personalObject.id)" target="_blank" class="sub-right"
          >详细信息</a
        >
      </div>
      <div class="sub-nav">
        <span
          :class="activeId === item.id ? 'isActive' : ''"
          v-for="item in subList"
          :key="item.id"
          @click="changeNav(item.name, item.id)"
          >{{ item.title }}</span
        >
        <!-- <router-link
          v-for="(nav, i) in subList"
          :key="i"
          :to="{
            name: nav.name,
            query: { title: $route.query.title, id: $route.query.id },
          }"
        >
          {{ nav.title }}
        </router-link> -->
      </div>
    </div>
  </div>
  <div
    class="sub-header-container"
    :style="{ top: scrollTop + 'px' }"
    v-else-if="$route.query.title === '机构号'"
  >
    <div class="sub-wrapper">
      <div class="sub-top">
        <div class="sub-left">
          <div class="avatar">
            <img
              v-lazy="$global.imgUrl + personalObject.coverImg"
              alt=""
              v-if="personalObject.coverImg"
            />
            <img
              :src="require('@/assets/img/details/qikan.png')"
              alt=""
              v-else
            />
          </div>
          <div class="personal1">
            <h2 class="name">{{ personalObject.name }}</h2>
            <div>
              主管单位：<span class="zg status">{{ personalObject.company }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="sub-nav">
        <span
          :class="activeId === item.id ? 'isActive' : ''"
          v-for="item in subList"
          :key="item.id"
          @click="changeNav(item.name, item.id)"
          >{{ item.title }}</span
        >
        <!-- <router-link
          v-for="(nav, i) in subList"
          :key="i"
          :to="{
            name: nav.name,
            query: { title: $route.query.title, id: $route.query.id },
          }"
        >
          {{ nav.title }}
        </router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeId: {
      type: Number,
      default: 0,
    },
    subList: {
      type: Array,
      default: () => [],
    },
    personalObject: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    // this.$bus.$on("mainScroll", this.handleScroll);
  },
  destroyed() {
    // this.$bus.$off("mainScroll", this.handleScroll);
  },
  data() {
    return {
      index: 0,
      scrollTop: 111,
    };
  },
  methods: {
    // 详细信息按钮 传递事件及ID
    toUrl(id) {
      // 如果点击了不在提醒,那么去问sessionStorage是否存值来判断
      if (localStorage.getItem("close")) {
        switch (this.$route.query.title) {
          case '百家在线':
            window.open(`${this.$global.baijiaUrl}autherplain?id=${id}`)
          break;
          case '百科在线':
            window.open(`${this.$global.baikeUrl}details?ids=${id}`)
          break;
        }
      } else {
        this.$bus.$emit("toBJUrl", id);
      }
    },
    changeNav(comName, id) {
      this.$emit("changeNav", comName, id);
    },
    handleScroll() {
      if (document.documentElement.scrollTop > this.scrollTop) {
        this.scrollTop = 0;
      } else {
        this.scrollTop = 111;
      }
    },
    handleClick(id, status) {
      let routeUrl = this.$router.resolve({
        path: "/recommend",
        query: {
          id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.sub-header-container {
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  height: 220px;
  margin: 19px 0;
  background-color: #fff;
  // box-shadow: 0px 15px 1px rgba(22, 26, 100, 0.04);
  z-index: 1;
  border: 1px solid #dcdcdc;
  .sub-wrapper {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    .sub-top {
      height: 100px;
      padding-top: 80px;
      margin-bottom: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .sub-left {
        display: flex;
        align-items: center;
        width: 1000px;
        .avatar {
          // background-color: #0b35c5;
          margin-right: 20px;
          img {
            width: 100px;
            height: 100px;
            border-radius: 50%;
          }
        }
        .title {
          width: 350px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          span {
            font-size: 18px;
            font-weight: bold;
            color: #333333;
          }
        }
        .title,
        .subject {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          margin-top: 15px;
        }
        .name {
          font-size: 30px;
          font-weight: bold;
          color: #263d78;
          width: 350px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .personal {
          span {
            font-size: 18px;
            font-weight: bold;
            color: #333333;
          }
        }
        .personal1 {
          div {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            margin-top: 20px;
            .zg,
            .zb {
              margin-right: 10px;
              font-size: 18px;
              font-weight: bold;
              color: #333333;
              cursor: pointer;
            }
          }
        }
        .status {
          font-size: 18px !important;
          font-weight: bold !important;
          color: #333333 !important;
          cursor: default !important;
        }
        .research {
          height: 81px;
          margin-left: 22px;
          .school {
            margin-top: 10px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 500px;
            span {
              font-size: 16px;
              font-weight: bold;
              color: #0b35c5;
              cursor: pointer;
            }
          }
          .subject {
            width: 500px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-top: 23px;
            span {
              font-size: 18px;
              font-weight: bold;
              color: #333333;
            }
          }
        }
      }
      .sub-right {
        width: 120px;
        height: 40px;
        background: #0b35c5;
        border-radius: 8px;
        cursor: pointer;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        color: #ffffff;
        margin-right: 30px;
      }
    }
    .sub-nav {
      margin-top: 80px;
      // a {
      //   font-size: 20px;
      //   font-weight: 400;
      //   color: #333333;
      //   cursor: pointer;
      // }
      span {
        margin: 0 30px;
        padding: 0 10px;
        font-size: 20px;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
      }
      .isActive {
        border-bottom: 3px solid #0b35c5;
        padding-bottom: 10px;
        font-weight: bold;
        color: #0b35c5;
      }
    }
  }
}
.router-link-exact-active,
.router-link-active {
  border-bottom: 3px solid #0b35c5;
  padding-bottom: 7px;
  font-weight: bold;
  color: #0b35c5;
}
</style>
